// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backButton":"qGc2a-","button":"_2cNykC","closeButton":"_3kiz6p","content":"q1Rj9w","navContainer":"cIFnNO"};